import { clone } from 'lodash';
import Request from '@/core/QuRequest';

const req = new Request();

export default {
  methods: {
    async userRoleList() {
      const res = await req.send(req.Apis.sales.user.userRoleList);
      if (res && res.code === 200) {
        this.data = res.data;
      }
    },

    async userRoleAdd(params) {
      const _params = clone(params);
      try {
        const res = await req.send(req.Apis.sales.user.userRoleAdd, params);
        if (res && res.code === 200) {
          const d = {
            ..._params,
            id: res.data.id,
          };
          this.data.unshift(d);
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    async userRoleDelete(params) {
      const res = await req.send(req.Apis.sales.user.userRoleDelete, params);
      if (res && res.code === 200) {
        const index = this.data.findIndex((d) => d.id === params.id);
        this.data.splice(index, 1);
      }
    },

    async userRoleEdit(params) {
      const _params = clone(params);
      try {
        const res = await req.send(req.Apis.sales.user.userRoleEdit, params);
        if (res && res.code === 200) {
          this.current.name = _params.name;
          this.current.code = _params.code;
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },

    // 获取权限组列表
    async getPermList() {
      const res = await req.send(req.Apis.sales.user.userPermList, {
        is_all: 0,
      });
      if (res && res.code === 200) {
        this.data = res.data;
      }
    },

    // 获取权限组列表
    async userRoleAttachPerms(params) {
      const res = await req.send(
        req.Apis.sales.user.userRoleAttachPerms,
        params,
      );
      if (res && res.code === 200) {
        console.dir(res);
      }
    },

    async userRoleGetPerms(params) {
      const res = await req.send(req.Apis.sales.user.userRoleGetPerms, params);
      if (res && res.code === 200) {
        this.selectedPerms = res.data;
      }
    },
  },
};
